import Constants from "./Constants";

export default class NumberUtils {
  static currencyIntervalAtoB(val, from, to) {
    let secs = val;

    if (from == to) {
      return val;
    }

    switch (from) {
      case Constants.CURRENCY_INTERVALS.SECOND:
        secs = val;

        break;
      case Constants.CURRENCY_INTERVALS.MINUTE:
        secs = val / 60;

        break;
      case Constants.CURRENCY_INTERVALS.HOUR:
        secs = val / 60 / 60;

        break;
      case Constants.CURRENCY_INTERVALS.DAY:
        secs = val / 60 / 60 / 24;

        break;
      case Constants.CURRENCY_INTERVALS.WEEK:
        secs = val / 60 / 60 / 24 / 7;

        break;
      case Constants.CURRENCY_INTERVALS.MONTH:
        secs = val / 60 / 60 / 24 / 30;

        break;
      case Constants.CURRENCY_INTERVALS.QUARTER:
        secs = val / 60 / 60 / 24 / 30 / 3;

        break;
      case Constants.CURRENCY_INTERVALS.YEAR:
        secs = val / 60 / 60 / 24 / 365;

        break;

      default:
        break;
    }

    switch (to) {
      case Constants.CURRENCY_INTERVALS.SECOND:
        return secs;
      case Constants.CURRENCY_INTERVALS.MINUTE:
        return secs * 60;
      case Constants.CURRENCY_INTERVALS.HOUR:
        return secs * 60 * 60;
      case Constants.CURRENCY_INTERVALS.DAY:
        return secs * 60 * 60 * 24;
      case Constants.CURRENCY_INTERVALS.WEEK:
        return secs * 60 * 60 * 24 * 7;
      case Constants.CURRENCY_INTERVALS.MONTH:
        return secs * 60 * 60 * 24 * 30;
      case Constants.CURRENCY_INTERVALS.QUARTER:
        return secs * 60 * 60 * 24 * 30 * 3;
      case Constants.CURRENCY_INTERVALS.YEAR:
        return secs * 60 * 60 * 24 * 365;
      default:
        return secs;
    }
  }

  static format(number) {
    return number.toLocaleString();
  }
}
